import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { LOGIN } from "../constants/routes";
import { RootState } from "../store/combineReducer";

export default function ProtectedRoute({ children }: any) {
  const { token } = useSelector((state: RootState) => state.auth);
  const location = useLocation();

  if (!token) return <Navigate to={LOGIN} state={location} />;

  return children;
}
